const e = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "previousAdmin",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "newAdmin",
        type: "address"
      }
    ],
    name: "AdminChanged",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "beacon",
        type: "address"
      }
    ],
    name: "BeaconUpgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_tokenReceiptHandlerAddress",
        type: "address"
      }
    ],
    name: "ContractSettingUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_stakingId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_duration",
        type: "uint256"
      }
    ],
    name: "StakedToken",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "_user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_stakingId",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      }
    ],
    name: "UnstakedToken",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "implementation",
        type: "address"
      }
    ],
    name: "Upgraded",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256[]",
        name: "_validDuration",
        type: "uint256[]"
      }
    ],
    name: "ValidDurationUpdated",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address[]",
        name: "_tokenAddressArray",
        type: "address[]"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "_isWhitelisted",
        type: "bool"
      }
    ],
    name: "WhitelistTokensUpdated",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address"
      }
    ],
    name: "getAddressStakingIdsMap",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stakingId",
        type: "uint256"
      }
    ],
    name: "getStakeInfoById",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stakingId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "stakerAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stakingStartTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stakingDuration",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "unstakeTime",
            type: "uint256"
          }
        ],
        internalType: "struct ApeironVipTokenStaking.LPStakingInfoStruct",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "getValidDuration",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_address",
        type: "address"
      }
    ],
    name: "getWalletActiveStakeInfo",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "stakingId",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "stakerAddress",
            type: "address"
          },
          {
            internalType: "address",
            name: "tokenAddress",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "totalAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stakingStartTime",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stakingDuration",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "unstakeTime",
            type: "uint256"
          }
        ],
        internalType: "struct ApeironVipTokenStaking.LPStakingInfoStruct[]",
        name: "",
        type: "tuple[]"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    name: "isWhitelistedToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddress",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_duration",
        type: "uint256"
      }
    ],
    name: "stakeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "stakingIdCounter",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_stakingId",
        type: "uint256"
      }
    ],
    name: "unstakeToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenReceiptHandlerAddress",
        type: "address"
      }
    ],
    name: "updateContractSetting",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "_validDuration",
        type: "uint256[]"
      }
    ],
    name: "updateValidDuration",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokenAddressArray",
        type: "address[]"
      },
      {
        internalType: "bool",
        name: "_isWhitelisted",
        type: "bool"
      }
    ],
    name: "updateWhitelistTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      }
    ],
    name: "upgradeTo",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newImplementation",
        type: "address"
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes"
      }
    ],
    name: "upgradeToAndCall",
    outputs: [],
    stateMutability: "payable",
    type: "function"
  }
];
export {
  e as default
};
//# sourceMappingURL=ronin-vip-token-staking.json.js.map
